import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class languageApi {
    private readonly baseUrl = 'api/v3/users/me/language';

    constructor(private httpClient: HttpClient) {}

    patch(language: string) {
        return this.httpClient.patch<void>(`${this.baseUrl}/${language}`, {});
    }
}
